import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCode, 
  faDesktop, 
  faMobile, 
  faServer, 
  faChartLine, 
  faLock 
} from '@fortawesome/free-solid-svg-icons';
import './Skills.css';

const services = [
  { 
    name: 'Web Development', 
    icon: faCode,
    description: 'Custom web applications built with cutting-edge technologies to meet your business requirements.' 
  },
  { 
    name: 'UI/UX Design', 
    icon: faDesktop,
    description: 'User-centered interfaces designed for optimal experience, accessibility and conversion.' 
  },
  { 
    name: 'Mobile Applications', 
    icon: faMobile,
    description: 'Cross-platform mobile solutions that deliver seamless experiences across all devices.' 
  },
  { 
    name: 'Backend & API Development', 
    icon: faServer,
    description: 'Robust, scalable server infrastructures and APIs that power your digital ecosystem.' 
  },
  { 
    name: 'Digital Strategy', 
    icon: faChartLine,
    description: 'Data-driven approaches to optimize your digital presence and business growth.' 
  },
  { 
    name: 'Security & Compliance', 
    icon: faLock,
    description: 'Implementation of best practices in security and regulatory compliance for your digital products.' 
  }
];

const Skills = () => (
  <section id="skills" className="skills section">
    <div className="container">
      <motion.div
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2>Our Services</h2>
        <p>Comprehensive solutions for your business needs</p>
      </motion.div>

      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="service-item"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={service.icon} />
            </div>
            <h3>{service.name}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;